import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Tab } from "@fluentui/react-components";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../store";
import { fetchCandidate } from "./candidate-slice";
import { fetchVacancyUids } from "../vacancy/vacancies-uids-slice";
import { ENTITY_CANDIDATE } from "../../utils/Constants";
import TabHeader from "../../blocks/tab/TabHeader";
import TabContent from "../../blocks/tab/TabContent";
import PageHeader from "../../blocks/PageHeader";
import BottomFixedButton from "../../blocks/BottomFixedButton";
import CandidateInfo from "./CandidateInfo";
import Vacancies from "../vacancy/Vacancies";
import Notes from "../note/Notes";
import DocumentSelection from "../document/DocumentSelection";

const CandidatePage = () => {
  const { uid } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [document, setDocument] = useState(null);
  const [selectedTab, setSelectedTab] = useState(location.state?.selectedTab || "general");
  const skipPageHeader = location.state?.skipPageHeader;

  const dispatch: AppDispatch = useDispatch();
  const { candidate, loading } = useSelector((state: RootState) => state.candidate);
  const { vacancyUids } = useSelector((state: RootState) => state.vacancyUids);

  useEffect(() => {
    if (uid) {
      dispatch(fetchCandidate(uid));
      dispatch(fetchVacancyUids({ uid, entity: ENTITY_CANDIDATE }));
    }
  }, [dispatch, uid]);

  const handleDocReady = (document) => {
    if (document) {
      setDocument(document);
      setSelectedTab("upload");
    }
  };

  const handleDocDetails = () => {
    navigate("/document-details", {
      state: { uid, entity: ENTITY_CANDIDATE, document, skipPageHeader, selectedTab },
    });
  };

  const handleNoteForm = () => {
    navigate("/note-form", {
      state: { uid, entity: ENTITY_CANDIDATE, skipPageHeader, selectedTab },
    });
  };

  return (
    <>
      {!skipPageHeader && <PageHeader onBack={() => navigate(-1)} />}
        
      {!loading && candidate && (
        <>
          <TabHeader
            name={`${candidate.Person?.firstName || ""} ${candidate.Person?.infix || ""} ${candidate.Person?.lastName || ""}`}
            status={candidate?.status}
            profileImage={candidate?.profileImage}
            entity={ENTITY_CANDIDATE}
            entityId={candidate?.uid}
          />
          <TabContent selectedTab={selectedTab} skipPageHeader={skipPageHeader} onTabChange={setSelectedTab}>
            <Tab value="general" name="General">
              <CandidateInfo candidate={candidate} />
            </Tab>
            <Tab value="applications" name="Applications">
              <Vacancies uids={vacancyUids} />
            </Tab>
            <Tab value="notes" name="Notes">
              <>
                <Notes entity={ENTITY_CANDIDATE} uid={candidate?.uid} />
                <BottomFixedButton appearance="primary" onClick={handleNoteForm} buttonText="New note" />
              </>
            </Tab>
            <Tab value="upload" name="Upload Documents">
              <>
                <DocumentSelection onReady={handleDocReady} />
                <BottomFixedButton
                  appearance="primary"
                  onClick={handleDocDetails}
                  disabled={!document}
                  buttonText="Next" />
              </>
            </Tab>
          </TabContent>
        </>
      )}
    </>
  );
};

export default CandidatePage;
